import { render, staticRenderFns } from "./PreviewPaper.vue?vue&type=template&id=13d76381&scoped=true&"
import script from "./PreviewPaper.vue?vue&type=script&lang=js&"
export * from "./PreviewPaper.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPaper.vue?vue&type=style&index=0&id=13d76381&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d76381",
  null
  
)

export default component.exports